import React from 'react';
import { BookOpenCheck, Users, LayoutTemplate, GraduationCap } from 'lucide-react';
const benefits = [{
  icon: BookOpenCheck,
  title: "Lezioni Pronte all'Uso",
  desc: "Materiali strutturati per affrontare tutti i nuclei tematici dell'Educazione Civica senza dover cercare nulla online.",
  color: 'text-blue-600',
  bgColor: 'bg-blue-50',
  borderColor: 'border-blue-100'
}, {
  icon: Users,
  title: 'Coinvolgimento Attivo',
  desc: 'Dibattiti guidati e compiti di realtà progettati per far partecipare attivamente gli studenti di ogni età.',
  color: 'text-emerald-600',
  bgColor: 'bg-emerald-50',
  borderColor: 'border-emerald-100'
}, {
  icon: LayoutTemplate,
  title: 'Programmazione Semplificata',
  desc: 'Documenti di programmazione annuale già compilati e pronti da consegnare in segreteria.',
  color: 'text-amber-600',
  bgColor: 'bg-amber-50',
  borderColor: 'border-amber-100'
}, {
  icon: GraduationCap,
  title: 'Valutazione Chiara',
  desc: 'Rubriche di valutazione e verifiche pronte per certificare le competenze civiche in modo oggettivo.',
  color: 'text-purple-600',
  bgColor: 'bg-purple-50',
  borderColor: 'border-purple-100'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-dark py-24 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-16 tracking-tight" data-id="element-3">
          Perché scegliere Educazione Civica Pronta:
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8" data-id="element-4">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <div key={i} className="bg-white p-8 rounded-3xl border border-border-light shadow-sm flex flex-col gap-4 hover:shadow-md transition-shadow" data-id="element-5">
                <div className={`w-14 h-14 rounded-2xl ${benefit.bgColor} border ${benefit.borderColor} flex items-center justify-center mb-2`} data-id="element-6">
                  <Icon className={`w-7 h-7 ${benefit.color}`} data-id="element-7" />
                </div>
                <h3 className="text-2xl font-bold text-text-main" data-id="element-8">
                  {benefit.title}
                </h3>
                <p className="text-text-sec leading-relaxed text-lg" data-id="element-9">
                  {benefit.desc}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}